/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeVo
 */
export interface VolumeVo {
    /**
     * 重量（kg）。
     * @type {number}
     * @memberof VolumeVo
     */
    weight?: number;
    /**
     * 长、宽、高（cm）。
     * @type {number}
     * @memberof VolumeVo
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof VolumeVo
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof VolumeVo
     */
    height?: number;
    /**
     * 体积（m³）。
     * @type {number}
     * @memberof VolumeVo
     */
    cbm?: number;
}

/**
 * Check if a given object implements the VolumeVo interface.
 */
export function instanceOfVolumeVo(value: object): value is VolumeVo {
    return true;
}

export function VolumeVoFromJSON(json: any): VolumeVo {
    return VolumeVoFromJSONTyped(json, false);
}

export function VolumeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
    };
}

export function VolumeVoToJSON(json: any): VolumeVo {
    return VolumeVoToJSONTyped(json, false);
}

export function VolumeVoToJSONTyped(value?: VolumeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
    };
}

